import React from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation, Redirect } from "react-router-dom";
import { useHistory } from "react-router";
import SlideRoutes from "@thenumber/react-slide-routes";
import { HOME_PATH_LIST } from "../helpers/constants";
import { LoginPage, WelcomePage } from "../pages";
import welcome from "../assets/images/welcome.jpg";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import NoAccountPage from "../pages/NoAccountPage";
import AuthHeader from "../components/order/AuthHeader";
import AuthRedirectRoute from "./hoc/AuthRedirectRoute";
import { isInternal } from "../helpers";

const HomeRoutes = () => {
  const location = useLocation();
  const { action } = useHistory();
  if (isInternal())
    return (
      <Redirect
        to={{
          pathname: "new-order",
          state: {
            noAnimate: true,
          },
        }}
      />
    );

  return (
    <Row className="mx-0">
      <Col md={6} xs={12} className="px-0">
        <img src={welcome} className="welcome-image" alt="welcome" />
      </Col>
      <Col md={6} xs={12} className="px-0">
        <AuthHeader className="home-header" />
        <SlideRoutes
          location={location}
          duration={action === "REPLACE" ? 0 : 500}
          pathList={HOME_PATH_LIST}
          animation="slide"
          destroy={false}
        >
          <AuthRedirectRoute path="/" exact component={WelcomePage} />
          <AuthRedirectRoute
            path="/no-account"
            exact
            component={NoAccountPage}
          />
          <AuthRedirectRoute path="/login" component={LoginPage} />
          <AuthRedirectRoute
            path="/forgot-password"
            component={ForgotPasswordPage}
          />
        </SlideRoutes>
      </Col>
    </Row>
  );
};

export default HomeRoutes;
